// Import lodash
import _ from 'lodash';
window._ = _;

// Import jQuery and Bootstrap JS plugins
import 'bootstrap';
import 'popper.js'; // Optional, depends on which Bootstrap components you're using
import $ from 'jquery';

window.$ = window.jQuery = $;

// Initialize tooltips
$('[data-toggle="tooltip"]').tooltip();

// Toggle password visibility
$("#show_hide_password").on("click", function(event) {
    event.preventDefault();
    const passwordField = $("#password");
    const type = passwordField.attr("type") === "text" ? "password" : "text";
    passwordField.attr("type", type);
    $('#show_hide_password').find('.fa-eye, .fa-eye-slash').toggleClass('fa-eye fa-eye-slash');
});

// Import Axios for HTTP requests
import axios from 'axios';

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
